<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Documentos dos Parceiros</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Documentos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Parceiro</th>
                    <th scope="col" class="border-0">Tipo de documento</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0">Data de criação</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(partnerDoc, index) in partnerDocs" :key="index">
                    <td></td>
                    <td class="text-left">{{ partnerDoc.Partner.Name }}</td>
                    <td>{{ partnerDoc.PartnerDocType.Name }}</td>
                    <td>
                      <span
                        :class="[
                          GetSpanClass(partnerDoc.PartnerDocStatus.Code),
                        ]"
                        >{{ partnerDoc.PartnerDocStatus.Name }}</span
                      >
                    </td>
                    <td>{{ partnerDoc.CreatedDate | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('PartnerDoc', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetPartnerDoc(partnerDoc.Id, true, false)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('PartnerDoc', 'Get')"
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="
                              GetPartnerDoc(partnerDoc.Id, true, true)
                            "
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingApprove ? 'disabled' : ''"
                            v-if="
                              partnerDoc.PartnerDocStatus.Code == '1' &&
                              !partnerDoc.IsExcluded &&
                              $isAuthorize('PartnerDoc', 'UpdateStatus')
                            "
                            v-on:click.stop="
                              ConfirmUpdatePartnerDocStatus($event, index, true)
                            "
                          >
                            <template v-if="loadingApprove">
                              <loader
                                :small="true"
                                :isLoading="loadingApprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-check mr-2"></i>
                              Aprovar
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingDisapprove ? 'disabled' : ''"
                            v-if="
                              partnerDoc.PartnerDocStatus.Code == '1' &&
                              !partnerDoc.IsExcluded &&
                              $isAuthorize('PartnerDoc', 'UpdateStatus')
                            "
                            v-on:click.stop="
                              ConfirmUpdatePartnerDocStatus(
                                $event,
                                index,
                                false
                              )
                            "
                          >
                            <template v-if="loadingDisapprove">
                              <loader
                                :small="true"
                                :isLoading="loadingDisapprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-times mr-2"></i>
                              Reprovar
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-if="
                              !partnerDoc.IsExcluded &&
                              $isAuthorize('PartnerDoc', 'Delete')
                            "
                            v-on:click="
                              ConfirmDeletePartnerDoc(
                                $event,
                                partnerDoc.PartnerDocType.Name,
                                partnerDoc.Partner.Name,
                                partnerDoc.Id
                              )
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-if="
                              partnerDoc.IsExcluded &&
                              $isAuthorize('PartnerDoc', 'Reactivate')
                            "
                            v-on:click="
                              ConfirmReactivatePartnerDoc(
                                $event,
                                partnerDoc.PartnerDocType.Name,
                                partnerDoc.Partner.Name,
                                partnerDoc
                              )
                            "
                          >
                            <i class="fas fa-plus mr-2"></i> Reativar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      partnerDocs == null ||
                      partnerDocs == undefined ||
                      partnerDocs.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormPartnerDoc"
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <nav v-if="!loadingModal" class="nav-steps" aria-label="breadcrumb">
        <ol
          style="background-color: #fff; padding: 0.75rem 0rem"
          class="breadcrumb"
        >
          <li class="breadcrumb-item">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 0)"
              :class="[pCurrentStep == 0 ? 'active' : '']"
              >Documento do Parceiro</a
            >
            <i
              class="fas fa-angle-right mx-2"
              aria-hidden="true"
              v-if="isSeeing && partnerDocStatusHistories.length > 0"
            ></i>
          </li>
          <li v-if="isSeeing && partnerDocStatusHistories.length > 0">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 1)"
              :class="[pCurrentStep == 1 ? 'active' : '']"
              >Histórico do status</a
            >
          </li>
        </ol>
      </nav>

      <!-- Partner Docs - Step: 0 -->
      <div v-if="!loadingModal && pCurrentStep === 0">
        <ValidationObserver ref="formValidation">
          <d-form-row>
            <!-- Partner.Id -->
            <d-col md="6" class="form-group">
              <label>Parceiro</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoPartnerDoc.Partner.Id"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="partner in partners"
                    v-bind:value="partner.Id"
                    v-bind:key="partner.Id"
                  >
                    {{ partner.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Tipo de documento</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoPartnerDoc.PartnerDocType.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in partnerDocTypes"
                    v-bind:value="type.Code"
                    v-bind:key="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row v-if="isSeeing">
            <!-- CreatedDate -->
            <label>Data de criação</label>
            <d-form-input
              type="text"
              v-bind:value="
                infoPartnerDoc.CreatedDate | date('DD/MM/YYYY - HH:mm')
              "
              readonly
            />
          </d-form-row>
          <!-- Url -->
          <d-form-row v-if="isCreating">
            <d-col md="12" class="form-group">
              <label>Arquivo</label>
              <b-form-file
                type="file"
                placeholder="Selecione ou arraste um arquivo"
                drop-placeholder="Solte o arquivo aqui"
                browse-text="Selecionar"
                accept="application/pdf"
                @change="SelectPartnerDocFile($event, true)"
                @input="SelectPartnerDocFile($event, false)"
              />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <!-- Partner Docs Status History - Step: 1 -->
      <div v-if="!loadingModal && pCurrentStep === 1 && isSeeing">
        <div class="float-left">
          <h5>Histórico de status</h5>
        </div>
        <div
          v-if="paginationStatusHistories.TotalItems > 0"
          class="float-right"
        >
          <h6 v-if="paginationStatusHistories.TotalItems > 0" class="m-0">
            {{ paginationStatusHistories.TotalItems | number }}
            {{ paginationStatusHistories.TotalItems > 1 ? " itens" : "item" }}
          </h6>
        </div>
        <div class="card-body p-0 pb-3 text-center">
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0">Status</th>
                <th scope="col" class="border-0">Usuário interno</th>
                <th scope="col" class="border-0">Data</th>
                <th scope="col" class="border-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(
                  PartnerDocStatusHistory, index
                ) in partnerDocStatusHistories"
                :key="index"
              >
                <td>
                  <span
                    :class="[
                      GetSpanClass(
                        PartnerDocStatusHistory.PartnerDocStatus.Code
                      ),
                    ]"
                    >{{ PartnerDocStatusHistory.PartnerDocStatus.Name }}</span
                  >
                </td>
                <td>{{ PartnerDocStatusHistory.UserInternal.Name }}</td>
                <td>
                  {{
                    PartnerDocStatusHistory.ChangedDate
                      | date("DD/MM/YYYY - HH:mm")
                  }}
                </td>
              </tr>
              <tr
                v-if="
                  partnerDocStatusHistories == undefined ||
                  partnerDocStatusHistories == null ||
                  partnerDocStatusHistories.length == 0
                "
              >
                <td colspan="5">Sem registros</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 border-top">
            <div class="pagination-nav">
              <b-pagination
                class="float-right"
                v-model="paginationStatusHistories.PageNumber"
                :total-rows="paginationStatusHistories.TotalItems"
                :per-page="paginationStatusHistories.RowsPerPage"
                aria-controls="my-table"
              ></b-pagination>
              <div class="float-left">
                <d-select
                  size="sm"
                  v-model="paginationStatusHistories.RowsPerPage"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </d-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddPartnerDocValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.IdPartner" :value="null">
            <option :value="null" selected>Parceiro</option>
            <option
              v-for="partner in partners"
              v-bind:key="partner.Id"
              v-bind:value="partner.Id"
            >
              {{ partner.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePartnerDocType" :value="null">
            <option :value="null" selected>Tipo de documento</option>
            <option
              v-for="type in partnerDocTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePartnerDocStatus" :value="null">
            <option :value="null" selected>Status</option>
            <option
              v-for="status in partnerDocStatus"
              v-bind:key="status.Code"
              v-bind:value="status.Code"
            >
              {{ status.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsExcluded" :value="null">
            <option :value="true">Removido</option>
            <option :value="false">Ativo</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('PartnerDoc', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo documento"
      v-on:click="OpenMNewPartnerDoc()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
export default {
  name: "partner-docs",
  data: function () {
    return {
      countFilter: 0,
      filter: {
        IdPartner: null,
        CodePartnerDocType: null,
        CodePartnerDocStatus: null,
        IsExcluded: false,
      },
      validatedFormValidation: false,
      listPending: false,
      loadingDownload: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      loadingApprove: false,
      loadingDisapprove: false,
      loadingPartnerDocStatusHistories: false,
      pCurrentStep: 0,
      idPartnerDoc: 0,
      mSteps: ["partnerDoc", "PartnerDocStatusHistory"],
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      paginationStatusHistories: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      partnerDocs: [],
      partnerDocTypes: [],
      partnerDocStatus: [],
      partnerDocStatusHistories: [],
      partners: [],
      infoPartnerDoc: {
        Partner: {
          Id: null,
        },
        PartnerDocType: {
          Code: null,
        },
        Url: null,
      },
      partnerDocFile: null,
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo documento",
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListPartnerDoc();
    },
    "pagination.RowsPerPage": function () {
      this.ListPartnerDoc();
    },
    "paginationStatusHistories.PageNumber": function () {
      this.ListPartnerDocStatusHistories(this.idPartnerDoc);
    },
    "paginationStatusHistories.RowsPerPage": function () {
      this.ListPartnerDocStatusHistories(this.idPartnerDoc);
    },
  },
  mounted() {
    if (this.$route.query.listPending == "true") {
      this.listPending = true;
      this.filter.CodePartnerDocStatus = "1";
    }
    this.ListPartnerDoc();
    this.ListPartnerDocType();
    this.ListPartnerDocStatus();
    this.ListPartner();
  },
  methods: {
    SelectPartnerDocFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      if (file.type == "application/pdf") {
        this.partnerDocFile = file;
      } else {
        this.$makeToast(
          "O arquivo selecionado não é um PDF válido",
          "danger",
          "Documento do parceiro"
        );
      }
    },
    AppendFormData(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormData(obj[property], fd, formKey);
          } else {
            if (typeof obj[property] === "number") {
              fd.append(formKey, obj[property].toString().replace(".", ","));
            } else {
              fd.append(formKey, obj[property]);
            }
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      return this.AppendFormData(object);
    },
    OpenMPartnerDoc: function () {
      this.validatedFormValidation = false;
      this.pCurrentStep = 0;
      this.$bvModal.show("mFormPartnerDoc");
    },
    OpenMNewPartnerDoc: function () {
      this.ResetInfoPartnerDoc();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo documento";
      this.OpenMPartnerDoc();
    },
    ResetInfoPartnerDoc: function () {
      this.infoPartnerDoc = {
        Partner: {
          Id: null,
        },
        PartnerDocType: {
          Code: null,
        },
        Url: null,
      };
    },
    AddPartnerDocValidated: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          if (this.partnerDocFile != null && this.partnerDocFile != undefined) {
            this.AddPartnerDoc();
          } else {
            this.$makeToast(
              "Selecione um arquivo",
              "danger",
              "Documento do parceiro"
            );
          }
        }
      });
    },
    AddPartnerDoc() {
      if (this.isCreating) {
        // Add
        this.loadingModal = true;
        let partnerDoc = this.infoPartnerDoc;
        partnerDoc = JSON.parse(JSON.stringify(partnerDoc));
        delete partnerDoc.Url;
        var formData = this.GetFormData(partnerDoc);
        formData.append("File", this.partnerDocFile, this.partnerDocFile.name);
        this.$store
          .dispatch("AddPartnerDoc", formData)
          .then(() => {
            this.$makeToast(
              "Sucesso ao adicionar o documento",
              "success",
              "Documento do parceiro"
            );
            this.ListPartnerDoc();
            this.$bvModal.hide("mFormPartnerDoc");
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível adicionar o documento",
              "danger",
              "Documento do parceiro",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListPartnerDoc();
    },
    ListPartnerDoc: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerDocType)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerDocStatus)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Partner.Id": this.filter.IdPartner,
          "Object.PartnerDocType.Code": this.filter.CodePartnerDocType,
          "Object.PartnerDocStatus.Code": this.filter.CodePartnerDocStatus,
          "Object.IsExcluded": this.filter.IsExcluded,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListPartnerDoc", { params: data })
        .then(
          (response) => {
            this.partnerDocs = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar os documentos",
              "danger",
              "Documentos dos parceiros",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    ListPartner: function () {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          this.partners = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de parceiros",
            error
          );
        });
    },
    ListPartnerDocType: function () {
      this.$store
        .dispatch("ListPartnerDocTypeUtil", { params: {} })
        .then((response) => {
          this.partnerDocTypes = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de tipos de documentos",
            error
          );
        });
    },
    ListPartnerDocStatus: function () {
      this.$store
        .dispatch("ListPartnerDocStatus", { params: {} })
        .then((response) => {
          this.partnerDocStatus = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de status de documentos",
            error
          );
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = {
        IdPartner: null,
        CodePartnerDocType: null,
        CodePartnerDocStatus: this.listPending ? "1" : null,
        IsExcluded: false,
      };
      this.ListPartnerDoc();
    },
    GetSpanClass: function (codePartnerDocStatus) {
      let variation = "badge badge-warning";
      if (codePartnerDocStatus == "2") {
        variation = "badge badge-success";
      } else if (codePartnerDocStatus == "3") {
        variation = "badge badge-danger";
      }
      return variation;
    },
    GetPartnerDoc: function (id, seeing, download) {
      if (download) this.loadingDownload = true;
      else this.loadingModal = true;
      if (!download) {
        if (seeing == true) {
          this.isSeeing = true;
          this.modalTitle = "Detalhes do documento";
        }
        this.isCreating = false;
        this.ResetInfoPartnerDoc();
        this.idPartnerDoc = id;
        this.ListPartnerDocStatusHistories(id);
        this.OpenMPartnerDoc();
      }

      this.$store
        .dispatch("GetPartnerDoc", { id: id })
        .then((response) => {
          this.infoPartnerDoc = response;

          if (download && hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Documento do parceiro"
            );
            window.open(response.Url, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do documento",
            "danger",
            "Documento do parceiro",
            error
          );
        })
        .finally(() => {
          if (download) this.loadingDownload = false;
          else this.loadingModal = false;
        });
    },
    ConfirmDeletePartnerDoc: function (e, nameDoc, namePartner, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${nameDoc} do parceiro ${namePartner}?`,
        "Confirmar",
        this.DeletePartnerDoc,
        i,
        nameDoc
      );
    },
    ConfirmReactivatePartnerDoc: function (e, nameDoc, namePartner, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja reativar ${nameDoc} do parceiro ${namePartner}?`,
        "Confirmar",
        this.ReactivatePartnerDoc,
        i,
        nameDoc
      );
    },
    DeletePartnerDoc: function (i, nameDoc) {
      this.$store
        .dispatch("DeletePartnerDoc", { id: i })
        .then(() => {
          this.$makeToast(
            `${nameDoc} foi removido da sua lista de arquivos`,
            "success",
            "Arquivo"
          );
          this.ListPartnerDoc();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o arquivo",
            error
          );
        });
    },
    ReactivatePartnerDoc: function (i, nameDoc) {
      this.$store
        .dispatch("ReactivatePartnerDoc", i)
        .then(() => {
          this.$makeToast(
            `${nameDoc} foi reativado na sua lista de arquivos`,
            "success",
            "Arquivo"
          );
          this.ListPartnerDoc();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao reativar o arquivo",
            error
          );
        });
    },
    ConfirmUpdatePartnerDocStatus: function (e, i, approve) {
      e.preventDefault();
      let partnerDoc = this.partnerDocs[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja ${
          approve ? "aprovar" : "reprovar"
        } este documento?`,
        "Confirmar",
        this.UpdatePartnerDocStatus,
        i,
        approve
      );
    },
    UpdatePartnerDocStatus: function (i, approve) {
      let codePartnerDocStatus = "";
      let partnerDoc = this.partnerDocs[i];

      if (approve) {
        this.loadingApprove = true;
        codePartnerDocStatus = "2";
      } else {
        this.loadingDisapprove = true;
        codePartnerDocStatus = "3";
      }

      let infoPartnerDoc = {
        Id: partnerDoc.Id,
        PartnerDocStatus: {
          Code: codePartnerDocStatus,
        },
      };
      this.$store
        .dispatch("UpdatePartnerDocStatus", infoPartnerDoc)
        .then(() => {
          this.$makeToast(
            "Sua solicitação foi processada com sucesso",
            "success",
            "Documentos dos Parceiros"
          );
          this.ListPartnerDoc();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao processar sua solicitação",
            error
          );
        })
        .finally(() => {
          if (approve) this.loadingApprove = false;
          else this.loadingDisapprove = false;
        });
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = {
        "Object.Partner.Id": this.filter.IdPartner,
        "Object.PartnerDocType.Code": this.filter.CodePartnerDocType,
        "Object.PartnerDocStatus.Code": this.filter.CodePartnerDocStatus,
        "Object.IsExcluded": this.filter.IsExcluded,
      };
      this.$store
        .dispatch("ReportPartnerDoc", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Geração de relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $(".dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
    ListPartnerDocStatusHistories: function (id) {
      this.partnerDocStatusHistories = [];
      this.loadingPartnerDocStatusHistories = true;
      let data = {
        ...this.paginationStatusHistories,
        ...{
          "Object.PartnerDoc.Id": id,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListPartnerDocStatusHistories", { params: data })
        .then(
          (response) => {
            this.partnerDocStatusHistories = response.Objects;
            this.paginationStatusHistories.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar o histórico de status dos documentos",
              "danger",
              "Histórico de status do documentos",
              error
            );
          }
        )
        .finally(() => {
          this.loadingPartnerDocStatusHistories = false;
        });
    },
    GoToStep: function (e, stepToGo) {
      e.preventDefault();
      if (stepToGo < this.mSteps.length && stepToGo >= 0) {
        this.pCurrentStep = stepToGo;
      }
    },
  },
};
</script>

<style scoped>
.fa-green {
  color: #0ac37f;
}
.fa-red {
  color: #ff0000;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/partnerdocs.vue